// This file is automatically generated. Do not edit it directly.
import { createClient } from "@supabase/supabase-js";
import type { Database } from "./types";

const SUPABASE_URL = "https://rcodbrmfqucqcqzvtpwh.supabase.co";
const SUPABASE_PUBLISHABLE_KEY =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InJjb2Ricm1mcXVjcWNxenZ0cHdoIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTU4NTU4MzgsImV4cCI6MjA3MTQzMTgzOH0.QjyuVnb4Ldu1-o5Y3F2f752jx_tWjoiFgnpOn7k1L0g";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(
  SUPABASE_URL,
  SUPABASE_PUBLISHABLE_KEY
);
